/**
 * The single place the Buy Me a Coffee destination and its wording live.
 *
 * The official Buy Me a Coffee button is a third-party script plus a hosted
 * image; both are ruled out by the no-CDN rule in DESIGN_SYSTEM.md and by the
 * published website privacy notice. Every placement is therefore a plain
 * anchor with the self-hosted `fa-mug-hot` glyph, themed from KDS roles.
 */
export const support = {
  href: 'https://buymeacoffee.com/keval.io',
  icon: 'fas fa-mug-hot',
  label: 'Buy me a coffee',
  element: 'buymeacoffee_link',
  footerNote: 'Everything here is free and ad-free.',
};
